module.exports = __webpack_public_path__ + "img/lever06.f805c77f.png";